// extracted by mini-css-extract-plugin
export default {"header":"style_header__6pPcG","headerContent":"style_headerContent__dCfTd","headerLogo":"style_headerLogo__09SHO","headerLink":"style_headerLink__4f9x-"};